import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { BillingTrackerSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportBillingTracker, sortBillingTracker } from '../../constants';
import { billingTrackerReport, billingAllTrackerReport } from '../../actions';
import { makeGetListBillingTracker, makeGetListAllBillingTracker } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let currencySelect = '';
let tableColumnsOutput = null;

class BillingTracker extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      year: moment().format('YYYY'),
      billStart: moment()
        .startOf('year')
        .format('YYYY-MM-DD'),
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listBillingTracker: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBillingTracker: props.listBillingTracker,
      totalCount: getPageTotalCount({ ...state, items: props.listBillingTracker }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetbillingTracker },
    } = this.props;
    if (modeGetbillingTracker) {
      this.doGetListBillingTracker();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBillingTracker();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListBillingTracker());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBillingTracker());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBillingTracker();
    });
  };

  doGetListBillingTracker = () => {
    const { filter, page, size, sorted } = this.state;
    const { billingTrackerReport } = this.props;
    const newFilter = cloneDeep(filter);
    // if (!newFilter.year) newFilter.year = moment().format('YYYY');
    if (!newFilter.exchangeCurrency) newFilter.exchangeCurrency = 'MXN';
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortBillingTracker[sorted.sortCol]
          ? sortBillingTracker[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    billingTrackerReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBillingTracker = cb => {
    const { filter, sorted } = this.state;
    const { billingAllTrackerReport } = this.props;
    const newFilter = cloneDeep(filter);
    // if (!newFilter.year) newFilter.year = moment().format('YYYY');
    if (!newFilter.exchangeCurrency) newFilter.exchangeCurrency = 'MXN';
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortBillingTracker[sorted.sortCol][sorted.sortDir] : null,
    };
    billingAllTrackerReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistBillingTracker(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllInvoicing, t } = this.props;
        convertJson2Pdf({
          data: listAllInvoicing,
          t,
          title: t('reportPage:sidebar.billingTracker').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.billingTracker')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          currency: currencySelect,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistBillingTracker(() => {
      const { listAllInvoicing, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf, filter, currency } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'BILLING_TRACKER_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.billingTracker')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.billingTracker')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllInvoicing,
            t,
            columns: tableColumnsOutput,
            // listOptionFields: { accountType: 'accountType', billType: 'billUnitType', paymentMethod: 'paymentMethod' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllInvoicing,
          t,
          title: t('reportPage:sidebar.billingTracker').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.billingTracker')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          currency: filter && filter.exchangeCurrency ? `(${filter.exchangeCurrency})` : '(MXN)',
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.billingTracker')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('BILLING_TRACKER_REPORT', ({ success, data }) => {
      if (success && data) {
        const { filter } = this.state;
        currencySelect = filter && filter.exchangeCurrency ? `(${filter.exchangeCurrency})` : '(MXN)';
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBillingTracker({ currency: currencySelect, t }),
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBillingTracker,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllInvoicing,
      t,
      permissions: { modeGetbillingTracker, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetbillingTracker) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    currencySelect = filter && filter.exchangeCurrency ? `(${filter.exchangeCurrency})` : '(MXN)';

    if (tableColumnsOutput && tableColumnsOutput.length) {
      tableColumnsOutput = tableColumnsOutput.map(val => {
        const { ...rest } = val;
        if (val && val.name === 'billedExchangeAmount') {
          rest.label = `${t('label.billedAmount')} ${currencySelect}`;
        }
        return { ...rest };
      });
    }
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.billingTracker') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.billingTracker')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <BillingTrackerSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.billingTracker').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllInvoicing,
                          t,
                          title: t('reportPage:sidebar.billingTracker').toLocaleUpperCase(),
                          currency: currencySelect,
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.billingTracker')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listBillingTracker}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listBillingTracker && listBillingTracker.length ? listBillingTracker : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

BillingTracker.propTypes = {
  billingTrackerReport: PropTypes.func,
  billingAllTrackerReport: PropTypes.func,
  listAllInvoicing: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

BillingTracker.defaultProps = {
  billingTrackerReport: () => {},
  billingAllTrackerReport: () => {},
  listAllInvoicing: [],
};

const mapStateToProps = createStructuredSelector({
  listBillingTracker: makeGetListBillingTracker() || [],
  listAllInvoicing: makeGetListAllBillingTracker() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    billingTrackerReport,
    billingAllTrackerReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(BillingTracker)
);
